import { render, staticRenderFns } from "./ShaanXiProvincePayComp.vue?vue&type=template&id=6bb62bd2&scoped=true&"
import script from "./ShaanXiProvincePayComp.vue?vue&type=script&lang=js&"
export * from "./ShaanXiProvincePayComp.vue?vue&type=script&lang=js&"
import style0 from "./ShaanXiProvincePayComp.vue?vue&type=style&index=0&id=6bb62bd2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb62bd2",
  null
  
)

export default component.exports